export default "__VITE_ASSET__k9H9jWJ0__"